import { render, staticRenderFns } from "./ItemViewModal.vue?vue&type=template&id=66b4b22f&"
import script from "./ItemViewModal.vue?vue&type=script&lang=js&"
export * from "./ItemViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports